export default "__VITE_ASSET__da52629b__"